let _ = t => t,
  _t;
import RouterTab from 'ui-addon-react-router-dom/RouterTab';
import RouterTabs from 'ui-addon-react-router-dom/RouterTabs';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ACHubSpotLogo } from '../ACHubSpotLogo';
import { ACCatalogMultiSelect } from '../ACCatalog/ACCatalogMultiSelect';
import { ACSearchInput } from '../ACSearchInput/ACSearchInput';
import { ACSearchInputProvider } from '../ACSearchInput/ACSearchInputProvider';
import { Flex } from 'foundations-components/components/Flex';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { MobilePage } from './MobilePage';
import { useTabsConfig } from './hooks/useTabsConfig';
import styledWithTheme from 'foundations-theming/utils';

/*
 * TODO: We want the horizontal divider border to be applied to the header component
 * instead of the main section wrapper component so that the border remains sticky
 * as well and intact while scrolling.
 *
 * Dashboard doesn't accept border style props for its header and main section
 * wrapper components.
 *
 * This hack is in place temporarily until the trellis team can support this functionality.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HorizontalDividerOverride = styledWithTheme.div(_t || (_t = _`
  [data-test-id="abstract-page-template-header"] {
    border-block-end: ${0};
  }

  [data-test-id="abstract-page-template-header"] + * {
    border-block-start: unset;
  }
`), ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`);
export const ACPage = ({
  children,
  isPartner
}) => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  const tabsConfig = useTabsConfig({
    isPartner
  });
  return /*#__PURE__*/_jsx(ACSearchInputProvider, {
    children: isMobileNavbar ? /*#__PURE__*/_jsx(MobilePage, {
      isPartner: isPartner,
      children: children
    }) : /*#__PURE__*/_jsx(HorizontalDividerOverride, {
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "1500",
          marginBlockEnd: "400",
          marginBlockStart: "1000",
          children: [/*#__PURE__*/_jsx(RouterLink, {
            to: "/",
            use: "unstyled",
            children: /*#__PURE__*/_jsx(ACHubSpotLogo, {})
          }), /*#__PURE__*/_jsxs(Flex, {
            flexGrow: 1,
            gap: "400",
            children: [/*#__PURE__*/_jsx(ACCatalogMultiSelect, {
              minBlockSize: "117px"
            }), /*#__PURE__*/_jsx(ACSearchInput, {
              maxInlineSize: "590px"
            })]
          })]
        }),
        headerWrapperStyles: {
          backgroundColor: 'fill-surface-default',
          position: 'sticky',
          insetBlockStart: '-26px',
          zIndex: 4
        },
        pageLayout: "full-width",
        tabs: /*#__PURE__*/_jsx(RouterTabs, {
          bordered: false,
          children: tabsConfig.map(tab => /*#__PURE__*/_jsx(RouterTab, {
            exact: tab.exact,
            tabId: tab.tabId,
            to: tab.to,
            title: tab.title
          }, tab.tabId))
        }),
        children: children
      })
    })
  });
};